import styled from 'styled-components';

export const StyledJobList = styled.section`
    padding: 200px 0;
    position: relative;
    .job-item-single {
        border-bottom: 1px solid rgba(21, 38, 55, 0.50);
        padding-bottom: 60px;
        margin-bottom: 60px;

        .title-wrapper {
            margin-bottom: 30px;

            h6 {
                color: #152637;
                font-size: 2rem; /* 32px / 16 */
                font-style: normal;
                font-weight: 500;
                line-height: 2.25rem; /* 36px / 16 */

            }
        }

        .content-wrapper {
            gap: 35px;
            width: 90%;

            .single-item {
                flex: 0 0 33.3333%;
                max-width: 33.3333%;

                p {
                    color: #152637;
                    font-size: 1rem; /* 16px / 16 */
                    font-style: normal;
                    font-weight: 500;
                    line-height: 1.5rem; /* 24px / 16 */
                    width: 70%;

                    &:first-child {
                        color: rgba(21, 38, 55, 0.5);
                        font-size: 1rem; /* 16px / 16 */
                        font-style: normal;
                        font-weight: 400;
                        line-height: 1.5rem; /* 24px / 16 */
                        width: 100%;
                    }
                }

                @media (max-width: 767px) {
                    flex: 0 0 100%;
                    max-width: 100%;
                }
            }

            @media (max-width: 767px) {
				flex-direction: column;
            }
        }

        &:last-child {
            border-bottom: none;
            padding-bottom: 0;
            margin-bottom: 0;
        }
    }
	@media(max-width: 767px){
		padding: 100px 0;
	}

`;
